import React from "react";
import api from "../../lib/api";
import { Autocomplete } from "../Autocomplete";
import { field, label, pill } from "./shared";

export const CapitalPartnerPick = ({ form, setForm, caps }) => (
  <div>
    <label className={label}>Capital partner <span className="text-destructive">*</span></label>
    <select data-testid="receiptdoc-capital-partner" className={field} value={form.received_from} onChange={(e) => setForm({ ...form, received_from: e.target.value })}>
      <option value="">Select partner…</option>
      {caps.map((c) => <option key={c.id} value={c.name}>{c.name}</option>)}
    </select>
    <p className="text-xs text-muted-foreground mt-1">Money received = capital <b>deposited (credit)</b> to this partner's account.</p>
  </div>
);

export const PayerFields = ({ form, setForm }) => (
  <>
    <div>
      <label className={label}>Account name</label>
      <Autocomplete field="account" testid="receiptdoc-account" value={form.account_name} onChange={(v) => setForm({ ...form, account_name: v })} placeholder="optional" />
    </div>
    <div className="grid grid-cols-2 gap-3">
      <div>
        <label className={label}>Received from</label>
        <Autocomplete field="party" testid="receiptdoc-from" value={form.received_from} onChange={(v) => setForm({ ...form, received_from: v, invoice_id: "" })} placeholder="Payer name" />
      </div>
      <div>
        <label className={label}>Mobile number</label>
        <input data-testid="receiptdoc-mobile" className={field} value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} placeholder="optional" />
      </div>
    </div>
  </>
);

const InvoicePick = ({ form, setForm, invoices, fillFromInvoice }) => {
  const choose = (e) => {
    const inv = invoices.find((i) => i.id === e.target.value);
    setForm({ ...form, invoice_id: e.target.value, invoice_no: "", invoice_date: "", invoice_balance: inv?.balance || 0, splits: inv ? [{ method: "cash", amount: String(inv.balance), reference: "" }] : form.splits, vehicle_number: inv?.vehicle_number || form.vehicle_number });
    if (inv) api.get("/invoices/lookup", { params: { invoice_no: inv.invoice_no } }).then((r) => fillFromInvoice(r.data)).catch((err) => console.debug(err));
  };
  return (
    <div className="space-y-2">
      <label className={label}>Select invoice</label>
      {form.received_from ? (invoices.length ? (
        <select data-testid="receiptdoc-invoice" className={field + " num"} value={form.invoice_id} onChange={choose}>
          <option value="">Choose an outstanding invoice…</option>
          {invoices.map((i) => <option key={i.id} value={i.id}>{i.invoice_no} · bal ₹{i.balance.toFixed(2)}</option>)}
        </select>
      ) : <p className="text-xs text-muted-foreground">No outstanding invoices for this party.</p>)
        : <p className="text-xs text-muted-foreground">Pick a party first.</p>}
      <div className="flex items-center gap-2 text-xs text-muted-foreground"><span className="flex-1 border-t border-border" />or type invoice no.<span className="flex-1 border-t border-border" /></div>
      <input data-testid="receiptdoc-invoice-no" className={field + " num"} placeholder="e.g. INV-00123 — auto-links to that invoice"
        value={form.invoice_no} onChange={(e) => setForm({ ...form, invoice_no: e.target.value, invoice_id: "", invoice_date: "", invoice_balance: 0 })} />
      {form.invoice_date ? <div data-testid="receiptdoc-invoice-date" className="text-xs text-accent">Invoice date: <span className="num">{form.invoice_date}</span></div> : null}
    </div>
  );
};

export const InvoiceModeSection = ({ form, setForm, invoices, fillFromInvoice }) => (
  <>
    <div>
      <label className={label}>Payment for</label>
      <div className="grid grid-cols-3 gap-2">
        {[{ v: "random", l: "Random Amount" }, { v: "individual", l: "Individual Invoice" }, { v: "bulk", l: "Bulk Invoices" }].map((m) => (
          <button key={m.v} type="button" data-testid={`receiptdoc-imode-${m.v}`} onClick={() => setForm({ ...form, invoice_mode: m.v, invoice_id: "" })}
            className={`h-10 rounded-md text-xs ${pill(form.invoice_mode === m.v)}`}>{m.l}</button>
        ))}
      </div>
    </div>
    {form.invoice_mode === "individual" && <InvoicePick form={form} setForm={setForm} invoices={invoices} fillFromInvoice={fillFromInvoice} />}
    {form.invoice_mode === "bulk" && form.received_from && (
      <div className="rounded-md bg-muted p-3 text-sm flex justify-between">
        <span className="text-muted-foreground">{invoices.length} outstanding invoice(s) — oldest paid first</span>
        <span className="num font-bold text-destructive">₹{invoices.reduce((s, i) => s + i.balance, 0).toFixed(2)}</span>
      </div>
    )}
  </>
);
